import { ca } from '@cian/analytics';

import { getDeveloperContactsLabel } from '../../../serp/components/header/developers_contacts';

interface ITrackButtonClick {
  isFavorite: boolean;
  newbuildingId: number;
}

export function trackButtonClick({ isFavorite, newbuildingId }: ITrackButtonClick) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: isFavorite ? 'add_from_about_JK' : 'remove_from_about_JK',
    label: getDeveloperContactsLabel(null),
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
  });
}
